import { h, Component } from 'preact'
import ErrorMessage from '../components/ErrorMessage'
import Loader from '../components/Loader'
import InstallationTypeAPI from '../api/InstallationTypeAPI'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class InstallationTypeFilter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      installationTypes: [],
      error: false,
      isLoading: true
    }

    this.handleInstallationType = this.handleInstallationType.bind(this)
  }

  componentDidMount() {
    this.fetchInstallationTypes()
  }

  fetchInstallationTypes() {
    this.setState({ isLoading: true })

    InstallationTypeAPI.all(this.props.slugs)
    .then(response => response.json())
    .then(data => {
      this.setState({
        installationTypes: [...this.state.installationTypes, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  handleInstallationType(e) {
    this.props.onSelectInstallationType(e.target.value)
  }

  generateOptions() {
    let options = []
    let option_text = 'Alles'

    if (this.props.language == 'en') {
      option_text = 'All'
    }

    // default option
    options.push(
      <option value="" key="0">{option_text}</option>
    )

    // make an option for each branch
    this.state.installationTypes.map((installationType) => {

      // skip branch if it has no projects
      if ( installationType.count === 0 ) return false

      return options.push(
        <option
          value={installationType.id}
          key={installationType.id}
          dangerouslySetInnerHTML={{ __html: installationType.name }}
        />
      )
    })

    return options
  }

  generateButtons() {
    let buttons = []

    // default button
    buttons.push(this.generateDefaultButton())

    // make an button for each branch
    this.state.installationTypes.map((installationType) => {

      // skip branch if it has no projects
      if ( installationType.count === 0 ) return false

      let buttonClass = 'c-button c-project-branches__button'

      if ( this.props.currentInstallationType == installationType.id ) {
        buttonClass = 'c-button c-project-branches__button c-project-branches__button--active'
      }

      return buttons.push(
        <button
          className={buttonClass}
          value={installationType.id}
          key={installationType.id}
          onClick={this.handleInstallationType}
          dangerouslySetInnerHTML={{ __html: installationType.name }}
        />
      )
    })

    return buttons
  }

  generateDefaultButton() {
    let defaultClass = 'c-button c-project-branches__button'
    let default_text = 'Alles'

    if ( this.props.currentInstallationType == '' ) {
      defaultClass = 'c-button c-project-branches__button c-project-branches__button--active'
    }

    if (this.props.language == 'en') {
      default_text = 'All'
    }

    return (
      <button className={defaultClass} value="" onClick={this.handleInstallationType}>
        {default_text}
      </button>
    )
  }

  render() {
    let {error, isLoading} = this.state

    if (error) {
      return <ErrorMessage type="filter-error" />
    }

    if (isLoading) {
      return <Loader />
    }

    let filter_text = 'Installatie types:'

    if (this.props.language == 'en') {
      filter_text = 'Installation types:'
    }

    return (
      <div className="c-project-branches">
        <p><strong>Installatie types</strong></p>
        <div className="c-project-branches__select-filter">
          <label className="c-project-branches__label">{filter_text}</label>
          <select
            value={this.props.currentInstallationType}
            onChange={this.handleInstallationType}
            className="c-project-branches__select"
          >
            {this.generateOptions()}
          </select>
        </div>

        <div className="c-project-branches__buttons-filter">
          {this.generateButtons()}
        </div>

      </div>
    )
  }
}

export default InstallationTypeFilter



// WEBPACK FOOTER //
// ./src/js/projects/containers/BranchFilter.js